import { render, staticRenderFns } from "./contractor-settlement-drawer.vue?vue&type=template&id=08cdcee0&scoped=true"
import script from "./contractor-settlement-drawer.vue?vue&type=script&lang=js"
export * from "./contractor-settlement-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cdcee0",
  null
  
)

export default component.exports